import React from 'react'

export interface ITooltip {
  tip: string
  children: React.ReactNode
}

const Tooltip = ({ tip, children }: ITooltip) => {
  return (
    <div className="group relative">
      {children}
      <span
        className="
            invisible
            absolute 
            -top-2 
            left-1/2 
            w-80
            -translate-x-3/4
            -translate-y-full
            rounded-md
            bg-main-blue
            px-4 
            py-1.5 
            font-spaceGrotesk 
            text-sm
            text-black
            opacity-0
            group-hover:visible
            group-hover:opacity-100
            sm:-translate-x-1/2
          ">
        <span
          className="
            absolute
            -bottom-2
            left-3/4
            h-0
            w-0
            -translate-x-1/2
            border-l-8
            border-r-8 border-t-8 border-l-transparent 
            border-r-transparent border-t-main-blue
            sm:left-1/2
          "></span>
        {tip}
      </span>
    </div>
  )
}

export default Tooltip
